// Jobs on the local output workshop (apps/course-ui/scripts/studio_output_workshop.py): start
// one, follow its log, get its result. Only the local preview server has the workshop.
export const OUTPUT_WORKSHOP = '/__studio/output';

let workshopAnswer = null;
/** Whether the local output workshop answers; asked once per page load. */
export function outputWorkshopAvailable() {
  workshopAnswer ??= fetch(`${OUTPUT_WORKSHOP}/status`, { cache: 'no-store' })
    .then(async response => response.ok && (await response.json()).available === true)
    .catch(() => false);
  return workshopAnswer;
}

/** POST { document } to `startUrl`, then follow the job until it is done; resolves its result. */
export async function runOutputJob(startUrl, documentValue, onProgress = () => {}, options = {}) {
  const response = await fetch(startUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...options, document: documentValue }) });
  const started = await response.json();
  if (!response.ok) throw new Error(started.error ?? `작업을 시작하지 못했습니다 (${response.status}).`);
  for (;;) {
    await new Promise(resolve => setTimeout(resolve, 1500));
    const job = await (await fetch(`${OUTPUT_WORKSHOP}/jobs/${started.id}`, { cache: 'no-store' })).json();
    onProgress(job.log.at(-1) ?? '');
    if (job.state === 'done') return job.result;
    if (job.state === 'failed') throw new Error(`${job.error}\n${job.log.slice(-8).join('\n')}`);
  }
}
